import React from 'react'
import HeaderComponent from '../components/HeaderComponent'

const Header = ({ pageProps }) => {
  return (
    <HeaderComponent
      title={pageProps.header}
      description={<span>{pageProps.description}</span>}
    />
  )
}

export default Header
